import React, { SVGProps } from 'react';

export const SvgAbundance = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="12"
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.75081 1.71145C11.3336 1.71145 14.0965 2.59285 16.0134 4.18505L19.4003 1.91926L18.154 5.66036L19.4003 9.39083L16.0134 7.12503C14.0971 8.71664 11.333 9.59864 8.75081 9.59864C7.40479 9.59864 6.10777 9.35895 5.00616 8.85597C2.70259 7.80336 1.71256 5.66095 1.71256 5.66095C1.71256 5.66095 2.70259 3.50791 5.00616 2.4553C6.10777 1.95232 7.40479 1.71263 8.75081 1.71263M8.75081 0.000590597C7.12142 0.000590597 5.58058 0.311119 4.29478 0.898526C1.49294 2.17665 0.28507 4.66501 0.156372 4.94484C-0.052615 5.40001 -0.0520246 5.92366 0.157553 6.37823C0.286251 6.65629 1.49412 9.13343 4.29419 10.4122C5.57999 10.9996 7.12083 11.3101 8.75022 11.3101C11.3519 11.3101 13.9926 10.5397 16.0535 9.21195L18.4474 10.8136C18.7361 11.0066 19.0679 11.1029 19.3991 11.1029C19.7657 11.1029 20.1317 10.9854 20.4375 10.7516C21.0196 10.3077 21.2546 9.54255 21.0226 8.84829L19.9576 5.65977L21.0232 2.46061C21.2546 1.76635 21.019 1.00184 20.4369 0.557888C20.1311 0.324697 19.7651 0.207216 19.3991 0.207216C19.0679 0.207216 18.7361 0.302854 18.4474 0.496491L16.0535 2.09813C13.992 0.769827 11.3519 0 8.75022 0L8.75081 0.000590597Z"
        fill="currentColor"
      />
      <path
        d="M4.88235 5.52166C5.34175 5.52166 5.71417 5.14925 5.71417 4.68985C5.71417 4.23045 5.34175 3.85803 4.88235 3.85803C4.42295 3.85803 4.05054 4.23045 4.05054 4.68985C4.05054 5.14925 4.42295 5.52166 4.88235 5.52166Z"
        fill="currentColor"
      />
    </svg>
  );
};
